import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=51da1d96&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51da1d96')) {
      api.createRecord('51da1d96', component.options)
    } else {
      api.reload('51da1d96', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=51da1d96&", function () {
      api.rerender('51da1d96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2w36wPP5Uv3xG/JS/comp/openstreetmap.vue"
export default component.exports